import React from 'react';
import { renderRoutes } from 'react-router-config';
import Helmet from 'react-helmet';
import compose from 'lodash.flowright';
import { SingletonHooksContainer } from 'react-singleton-hook';

import routes from './routes/routes';
import ConfirmModal from './components/global/ConfirmModal';
import ReportPhotoModal from './components/global/ReportPhotoModal';
import ShareBlockModal from './components/global/ShareBlockModal';
import SentryUserInitContainer from './containers/analytics/SentryUserInitContainer';
import ConfirmWithPasswordModalContainer from './containers/global/ConfirmWithPasswordModalContainer';
import withGoogleTagManager from './containers/analytics/withGoogleTagManager';
import AlertModal from './components/global/AlertModal';
import { StoreReferralAttributes } from './hooks/useStoreReferralAttributes';
import { SocialShareUrlModal } from './components/global/SocialShareUrl';
import { PurchaseSuccessWithReferralModal } from './components/global/PurchaseSuccessWithReferral';
import ShareSheet from './components/global/ShareSheet/ShareSheet';
import { StripeCheckout } from './components/global/StripeCheckout';
import SupportModal from './components/product/SupportModal';
import ConsumerFeedbackModal from './components/global/ConsumerFeedbackModal';
import QRCodeModal from './components/global/QRCodeModal/QRCodeModal';
import PlicBooksProgressBanner from './services/plic-books/components/PlicBooksProgressBanner/PlicBooksProgressBanner';
import { PhotoFinderCreditItemsCheckoutModal } from './apps/pro/views/Account/AccountPhotoManagerSettings/components/PhotoFinderCreditItemsCheckout';
import GlobalToast from './components/global/GlobalToast';
import useGtagTracking from './services/gtag/useGtagTracking';
import { ThankYouModal } from './components/global/ThankYouView';
import useDevToolsLimiters from './services/general/useDevToolsLimiters';

const AppContainer = () => {
  useGtagTracking();
  useDevToolsLimiters();

  return (
    <div className="app-container">
      <Helmet>
        <title>Waldo Photos</title>
      </Helmet>

      <SingletonHooksContainer />
      <SentryUserInitContainer />

      {renderRoutes(routes)}

      <ConfirmModal />
      <ConfirmWithPasswordModalContainer />
      <AlertModal />
      <ReportPhotoModal />
      <ShareBlockModal />
      <StoreReferralAttributes />
      <PurchaseSuccessWithReferralModal />
      <SocialShareUrlModal />
      <ShareSheet />
      <StripeCheckout />
      <SupportModal />
      <ConsumerFeedbackModal />
      <QRCodeModal />
      <PlicBooksProgressBanner forceOpen />
      <PhotoFinderCreditItemsCheckoutModal />
      <GlobalToast />
      <ThankYouModal />
    </div>
  );
};

export default compose(withGoogleTagManager)(AppContainer);
